export default __webpack_public_path__ + "AssetsCombined_312efcd8b96f3331767396be5f7abc3e.json";